import { SvgCommonProperties } from '../../interfaces/svg.interfaces';

export default function PlusSvg(props: SvgCommonProperties) {
  return <svg height={props.height} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <rect x="45" y="10" width="10" height="80" fill="inherit" />
    <rect x="10" y="45" width="80" height="10" fill="inherit" />
  </svg>

}